import { render, staticRenderFns } from "./MoleculeBuildingLabel.vue?vue&type=template&id=6c2ea0b2&"
import script from "./MoleculeBuildingLabel.vue?vue&type=script&lang=js&"
export * from "./MoleculeBuildingLabel.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeBuildingLabel.vue?vue&type=style&index=0&id=6c2ea0b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports